<template>
  <div>
    <panel-group :countData="countData"></panel-group>
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <div style="padding: 10px  0 ;font-size: 16px">处理消息数</div>
      <el-date-picker
        v-model="lineChartMounth"
        type="month"
        :clearable="false"
        @change="getLineData"
        placeholder="选择月份">
      </el-date-picker>
      <line-chart :chart-data="lineChartData" height="500px" />
    </el-row>


    <el-row v-if="0" :gutter="32">
      <el-col :xs="24" :sm="24" :lg="8">
        <div class="chart-wrapper">
          <raddar-chart />
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="8">
        <div class="chart-wrapper">
          <pie-chart />
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="8">
        <div class="chart-wrapper">
          <bar-chart />
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
// 1. 导入 echarts
import echarts from 'echarts'
import _ from 'lodash'
import PanelGroup from '@/components/dashboard/PanelGroup'
import LineChart from '@/components/dashboard/LineChart'
import RaddarChart from '@/components/dashboard/RaddarChart'
import PieChart from '@/components/dashboard/PieChart'
import BarChart from '@/components/dashboard/BarChart'
import { chat_get } from '@/api'
const lineChartData = {
}
export default {
  data() {
    return {
      countData: {
        "AnonymousNum": 0, // 匿名用户数
        "MessageNum": 0, // 消息数
        "TotalNum": 0, // 在线总数
        "UserNum": 0, // 用户数
        "KfNum": 0 // 客服数
      },
      lineChartData: [],
      lineChartMounth: new Date()
    }
  },
  created() {
    this.getBoardNumber();
    this.getLineData()
  },
  methods: {
    getBoardNumber() {
      let vm = this;
      chat_get('/admin/index',{} , res => {
        vm.countData = res.data.MessageContent.onlineNum
      })
    },
    getLineData() {
      let m = this.lineChartMounth.getMonth() + 1
      let data = {
        date: this.lineChartMounth.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-01'
      }
      chat_get('/admin/indextwo', data , res => {
        this.lineChartData = res.data.MessageContent || []
      })
    }
  },
  components: {
    PanelGroup,
    LineChart,
    RaddarChart,
    PieChart,
    BarChart
  }
}

</script>

<style scoped>
</style>
